module.exports = __webpack_public_path__ + "img/EZ-ANT.7fbd7759.jpg";